module.exports = "/images/google-play.png?7f3ffc86b142141dad1118fd4fcafb31";